import React from "react"
import {
    Box,
    componentStyles,
    TextLargeBold,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import LodgeList from "~components/pages/outfitter/lodgings/lodge-list"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { useLodgingQuery } from "~graphql/generated/graphql"

export default function IncludedLodging() {
    const styles = useStyles()
    const { pricingPackage } = useCheckoutFlow()

    const includedPricingPackageId = pricingPackage?.included_lodging_id ?? ""

    const { data, loading, error } = useLodgingQuery({
        variables: {
            id: includedPricingPackageId,
        },
        skip: !includedPricingPackageId,
    })

    const lodgings = data ? [data.lodging] : []

    return (
        <Box style={styles.root}>
            <TextLargeBold style={styles.label}>
                {COPY.LODGINGS.CHECKOUT_INCLUDED_LODGING}
            </TextLargeBold>
            <LoadingOrErrorContainer
                error={error}
                isLoading={loading}
                shouldRenderChildren={!!data}
            >
                <LodgeList lodgings={lodgings} />
            </LoadingOrErrorContainer>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            paddingTop: "10px",
            paddingBottom: "10px",
        },
        label: {
            lineHeight: 1.5,
            marginTop: 0,
            marginBottom: "16px",
        },
    })
}
